import AnimatedPopup from "../core/AnimatedPopup";
import Strings from "../core/data/Strings";
import ResizableScene from "../core/ResizableScene";
import ScaleManager from "../core/ScaleManager";
import ARIA from "../utils/ARIA";
import Fonts from "../utils/Fonts";
import GameColors from "../utils/GameColors";

export class ConfirmQuitPopup extends AnimatedPopup {
	private _onResize: () => void;
	_yesPressed: () => void;
	yesContext: CallbackContext;
	_noPressed: () => void;
	noContext: CallbackContext;

	scene: ResizableScene;
	constructor(
		scene: ResizableScene,
		yesPressed?: () => void,
		yesContext?: CallbackContext,
		noPressed?: () => void,
		noContext?: CallbackContext
	) {
		super(scene, 0, 0);
		this.scene = scene;
		this.setDepth(5);

		//this.scene.soundManager.play("quitSFX");

		if (noPressed) this._noPressed = noPressed;
		if (this.noContext) this.noContext = noContext;

		if (this.yesPressed) this._yesPressed = yesPressed;
		if (yesContext) this.yesContext = yesContext;

		const overlay = (this._overlay = scene.add.sprite(0, 0, "popupOverlay"));
		overlay.setScale(Math.max(scene.viewport.width / overlay.width, scene.viewport.height / overlay.height));
		this.add(overlay);

		const popupContainer = (this._popupGroup = scene.add.container(0, 0));
		this.add(popupContainer);

		const background = scene.add.nineSlicedSprite(0, 0, "popupBG", 1000, 600, 50, 50, 50, 50, null, false);
		popupContainer.add(background);
		popupContainer.setSize(background.slicedWidth, background.slicedHeight);

		const header = scene.add.image(0, 0, "popupSmallHeader");
		const headerText = scene.add.text(0, 0, Strings.get("Exit").toUpperCase(), {
			color: GameColors.WHITE,
			fontFamily: Fonts.MontserratBold,
			fontSize: "70px",
			align: "center",
		});
		popupContainer.add([header, headerText]);

		const descBacker = scene.add.image(0, 0, "popupTextBG");
		const desc = scene.add.text(0, 0, Strings.get("ConfirmQuit"), {
			color: GameColors.PURPLE,
			fontFamily: Fonts.MontserratBold,
			fontSize: "50px",
			align: "center",
		});
		popupContainer.add([descBacker, desc]);

		const yesButton = scene.add.button(0, 0, "checkBtn", null, this.yesPressed, this, true);
		popupContainer.add(yesButton);

		const noButton = scene.add.button(0, 0, "xBtn", null, this.noPressed, this, true);
		popupContainer.add(noButton);

		this._onResize = (): void => {
			scene.alignIn.Center(popupContainer, scene.viewport);
			ScaleManager.ScaleBackgroundFromZone(overlay, scene.viewport);
			scene.alignIn.Center(overlay, scene.viewport);

			// scene.alignIn.Center(background, scene.viewport);
			scene.alignIn.TopCenter(header, background, 0, 50);
			scene.alignIn.Center(headerText, header);

			scene.alignIn.Center(descBacker, background, 0, -50);
			scene.alignIn.Center(desc, descBacker);

			scene.alignIn.BottomCenter(yesButton, background, -150, 50);
			scene.alignIn.BottomCenter(noButton, background, 150, 50);
		};
		this.resize();

		const ariaLayer = "quit-popup";
		headerText.setARIA(ariaLayer, true);
		desc.setARIA(ariaLayer);
		yesButton.setARIA("Yes", ariaLayer);
		noButton.setARIA("No", ariaLayer);
		ARIA.showLayer(ariaLayer, true);

		this.intro();
	}

	resize(): void {
		super.resize();
		if (this._onResize != null) this._onResize();
	}

	yesPressed(): void {
		if (this._yesPressed) {
			if (this.yesContext) this._yesPressed.call(this.yesContext);
			else this._yesPressed();
		}

		this.scene.scene.start("PreloaderScene", {
			destinationScene: "LevelSelectScene",
		});
	}

	noPressed(): void {
		if (this._noPressed) {
			if (this.noContext) this._noPressed.call(this.noContext);
			else this._noPressed();
		}

		this.destroy();
		//this.tweenOut();
	}

	tweenOut(): void {
		const tweenOut = this.scene.add.tween({
			targets: this._popupGroup,
			y: { from: this.y, to: this.y + 1000 },
			duration: 400,
			ease: Phaser.Math.Easing.Back.In,
		});
		this.scene.add.tween({
			targets: this._overlay,
			alpha: 0,
			duration: 300,
		});
		tweenOut.once(Phaser.Tweens.Events.TWEEN_COMPLETE, this.destroy, this);
	}
}
